import { patchRequest } from '@/core';
import { tripAddresses } from '@/requests';

export default async function updateTerminalRequest(id, patch) {
	let url = tripAddresses.getByIdPath(id);
	let response = await patchRequest(url, {}, patch);
	return response;
}